import { createContext, useState, useCallback, type ReactNode, useContext } from 'react';

interface FeedbackContextType {
    isOpen: boolean;
    setIsOpen: (open: boolean) => void;
    feedbackContext: any;
    openFeedback: (context?: {
        passageId?: string;
        contextType?: string;
        modelInfo?: string;
        contentId?: string;
    }) => void;
}

export const FeedbackContext = createContext<FeedbackContextType | null>(null);

export function useFeedback() {
    const context = useContext(FeedbackContext);
    if (!context) {
        throw new Error('useFeedback must be used within a FeedbackProvider');
    }
    return context;
}

export function FeedbackProvider({ children }: { children: ReactNode }) {
    const [isOpen, setIsOpen] = useState(false);
    const [feedbackContext, setFeedbackContext] = useState<{
        passageId?: string;
        contextType?: string;
        modelInfo?: string;
        contentId?: string;
    } | undefined>(undefined);

    const openFeedback = useCallback((context?: {
        passageId?: string;
        contextType?: string;
        modelInfo?: string;
        contentId?: string;
    }) => {
        setFeedbackContext(context);
        setIsOpen(true);
    }, []);

    return (
        <FeedbackContext.Provider value={{ isOpen, setIsOpen, feedbackContext, openFeedback }}>
            {children}
        </FeedbackContext.Provider>
    );
}
